import { useEffect } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PAGADORES_FACTORAJE } from "@/lib/factoraje";

const AYUDA = {
  deudor: "El pago del deudor registrado no genera alerta de pago de tercero. Si el deudor tiene coincidencia en listas, el pago se registra y se avisa al Oficial de Cumplimiento.",
  cliente: "Pago hecho por el propio cliente (cedente de la factura).",
  tercero: "El pago de otro tercero genera la alerta PLD de pago de tercero, como hoy.",
};

// Build 3 · Factoraje: quién paga la operación. Default: deudor registrado.
export function PagadorFactorajeSelect({ credito, value, nombreTercero, onChange, showLabel = true, className = "" }) {
  useEffect(() => {
    if (!value) onChange({ pagador: "deudor" });
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const v = value || "deudor";
  return (
    <div className={`space-y-2 ${className}`} data-testid="pagador-factoraje">
      <div>
        {showLabel && <Label className="mb-1 block text-xs">Pagador</Label>}
        <Select value={v} onValueChange={(x) => onChange({ pagador: x, ...(x !== "tercero" ? { nombre_tercero: "" } : {}) })}>
          <SelectTrigger data-testid="pagador-factoraje-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            {PAGADORES_FACTORAJE.map((p) => (
              <SelectItem key={p.value} value={p.value} data-testid={`pagador-opcion-${p.value}`}>{p.label(credito)}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {v === "tercero" && (
        <div>
          <Label className="mb-1 block text-xs">Nombre del tercero</Label>
          <Input data-testid="pagador-nombre-tercero" value={nombreTercero || ""}
            onChange={(e) => onChange({ nombre_tercero: e.target.value })} />
        </div>
      )}
      <p className="text-[11px] text-slate-500" data-testid="pagador-ayuda">{AYUDA[v]}</p>
    </div>
  );
}
